export const iconFontAwesomeSocialComment = (
	<i className="fa-solid fa-comment"></i>
);
